// extracted by mini-css-extract-plugin
module.exports = {"root":"tendance-component_root__2r5zN","trendBloc":"tendance-component_trendBloc__1pr5d"};